export function safeCall<T>(fn: () => T): T | null {
  try {
    return fn();
  } catch (error) {
    return null;
  }
}
